import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import styles from "../../../ActiveLearningIssue.module.scss";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  const question3 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 3);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          原因を解消し、問題が取り除かれた理想状況を考えておくことで、その先にやるべき行動を考えやすくなる。原因が解消された理想状況を入力しよう。
        </p>
        <p className={styles.example}>
          例：原因「〇〇市の子育て支援が充実していない」→理想状況「〇〇市の子育て支援が充実している」
        </p>
      </div>
      {question1 && (
        <div className={styles.question}>
          <div className={styles.tree}>
            <ul className={clsx(styles.answerList, styles.wide)}>
              <li className={clsx(styles.answer, styles.single)}>
                回答データがありません。
              </li>
            </ul>
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>原因</span>
                </div>
                <ul className={styles.answerList}>
                  <li className={clsx(styles.answer, styles.single)}>
                    回答データがありません。
                  </li>
                </ul>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>理想状況</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
      {question2 && (
        <div className={styles.question}>
          <div className={styles.tree}>
            <ul className={clsx(styles.answerList, styles.wide)}>
              <li className={clsx(styles.answer, styles.single)}>
                回答データがありません。
              </li>
            </ul>
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>原因</span>
                </div>
                <ul className={styles.answerList}>
                  <li className={clsx(styles.answer, styles.single)}>
                    回答データがありません。
                  </li>
                </ul>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>理想状況</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
      {question3 && (
        <div className={styles.question}>
          <div className={styles.tree}>
            <ul className={clsx(styles.answerList, styles.wide)}>
              <li className={clsx(styles.answer, styles.single)}>
                回答データがありません。
              </li>
            </ul>
            <ul className={styles.branchList}>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>原因</span>
                </div>
                <ul className={styles.answerList}>
                  <li className={clsx(styles.answer, styles.single)}>
                    回答データがありません。
                  </li>
                </ul>
              </li>
              <li className={styles.branch}>
                <div className={styles.labelWrapper}>
                  <span className={styles.label}>理想状況</span>
                </div>
                <div className={styles.inputField}>
                  <TextInput />
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue2Material;
